import { action, computed, makeObservable, observable } from "mobx";
import { LibraryScoreItem } from "../../interfaces/scores";
import dayjs from "dayjs";
import { TrackStore } from "../tracks/track.store";
import { LibraryScoreItemPivotStore } from "./library-score-item-pivot.store";
import { LibraryType } from "../../constants";

export class LibraryScoreItemStore implements LibraryScoreItem {
	@observable id = 0;
	@observable service_id = 0;
	@observable library_type_id = 0;
	@observable sort = 0;
	@observable name = "";
	@observable is_active = false;
	@observable is_repeat = false;
	@observable repeat_start = dayjs();
	@observable repeat_end = dayjs();
	@observable tracks: TrackStore[] = [];
	@observable pivot = new LibraryScoreItemPivotStore(null);

	constructor(initialData: LibraryScoreItem | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@computed
	get nameTrack() {
		return this.pivot.name || this.name;
	}

	@computed
	get isSingle() {
		return this.library_type_id === LibraryType.SINGLE;
	}

	@action
	fillStore(data: LibraryScoreItem) {
		const {
			id,
			service_id,
			library_type_id,
			sort,
			name,
			is_active,
			is_repeat,
			repeat_start,
			repeat_end,
			tracks,
			pivot,
		} = data;

		this.id = id;
		this.service_id = service_id;
		this.library_type_id = library_type_id;
		this.sort = sort;
		this.name = name;
		this.is_active = is_active;
		this.is_repeat = is_repeat;
		this.repeat_start = repeat_start;
		this.repeat_end = repeat_end;
		this.tracks = (tracks || []).map((track) => new TrackStore(track));
		this.pivot = new LibraryScoreItemPivotStore(pivot);
	}
}
